import { ContainerBlot } from 'parchment';

class Container extends ContainerBlot {}

export default Container;



// WEBPACK FOOTER //
// ../../src/blots/container.ts